import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface ResponsePatients {
  id: number
  username: string
  person_general: {
    full_name: string
    cellphone_number: string
    email: string
  },
  consultations_held: number
  last_schedule_plan_code: string
}

interface Response {
  data: {
    patients: ResponsePatients[]
  }
}

interface Error {
  response: {
    status: number
  }
}

interface Patient {
  id: number
  username: string
  email: string
  fullName: string
  lastSchedulePlanCode: string
}

interface ListPatientsData {
  patients: Patient[]
}

interface ListPatientsProps {
  sort?: 'asc' | 'desc'
  query?: string
}

export const listPatients = ({
  sort,
  query,
}: ListPatientsProps = {}): Promise<ListPatientsData> => {

  const endpoint = apiEndpoints.PERSONS_PATIENTS

  const params = {
    ...(sort && { sort }),
    ...(query && { query }),
  }
  
  return new Promise<ListPatientsData> ((resolve, reject) => {
    axios.get(endpoint, { params })
      .then((response: Response) => {
        const patients = response.data.patients.map(patient => {
          return {
            id: patient.id,
            username: patient.username,
            email: patient.person_general.email,
            fullName: patient.person_general.full_name,
            lastSchedulePlanCode: patient.last_schedule_plan_code
          } as Patient
        })

        resolve({ patients })
      })
      .catch((error: Error) => {
        reject(error.response.status)
      })
  })
}